
import axios from 'axios';
import apiConfig from './apiConfig';

const apiService = axios.create({
    baseURL: apiConfig.apiUrl,
});

export async function fetchData(controller, params, token) {
    try {

        const response = await apiService.get(`/${controller}${params}`, {
            headers: {
                Authorization: `Bearer ${token}`, // Set Authorization header
                'Content-Type': 'application/json', // Set Content-Type header
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}



export async function postData(controller, data, token) {
    try {
        const response = await apiService.post(`/${controller}`, data, {
            headers: {
                Authorization: `Bearer ${token}`, // Set Authorization header
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function postLogin(controller, data) {
    try {
        const response = await apiService.post(`/${controller}`, data);
        return response.data;
    } catch (error) {
        throw error;
    }
}


export async function updateData(controller, id, data, token) {
    try {
        const response = await apiService.put(`/${controller}/${id}`, data, {
            headers: {
                Authorization: `Bearer ${token}`, // Set Authorization header
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function deleteData(controller, id, token) {
    try {
        const response = await apiService.delete(`/${controller}/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`, // Set Authorization header
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function activateData(controller, id, token) {
    try {
        const response = await apiService.put(`/${controller}/${id}/activate`, null, {
            headers: {
                Authorization: `Bearer ${token}`, // Set Authorization header
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function SyncData(controller, id, token) {
    try {
        const response = await apiService.put(`/${controller}/${id}/update`, null, {
            headers: {
                Authorization: `Bearer ${token}`, // Set Authorization header
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function SyncReprint(controller, id, userId, token) {
    try {
        const response = await apiService.put(`/${controller}/${id}/${userId}/update`, null, {
            headers: {
                Authorization: `Bearer ${token}`, // Set Authorization header
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function fetchhistory(controller, companyId, customerId, token) {
    try {
        const response = await apiService.get(`/${controller}/${companyId}/${customerId}`, {
            headers: {
                Authorization: `Bearer ${token}`, // Set Authorization header
                'Content-Type': 'application/json', // Set Content-Type header
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}




export async function fetchCountHistory(controller, date, companyId, engineerId, token) {
    try {
        const response = await apiService.get(`/${controller}/${date}/${companyId}/${engineerId}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function fetchCountDetails(controller, selecetddate, companyId, engineerId, token) {
    try {
        const response = await apiService.get(`/${controller}/${selecetddate}/${companyId}/${engineerId}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function fetchAppointmentList(controller, date, companyId, token) {
    try {
        const response = await apiService.get(`/${controller}/${date}/${companyId}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function fetchAppointmentDetails(controller, selecetddate, companyId, token) {
    try {
        const response = await apiService.get(`/${controller}/${selecetddate}/${companyId}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}


export const sendWhatsAppMessage = async (pdfData, customerContact) => {
    try {
        const formData = new FormData();
        formData.append('file', pdfData, 'invoice.pdf');

        // Construct WhatsApp message
        const message = `Dear Customer, please find your invoice attached.`;

        // Construct WhatsApp URL
        const url = `https://api.whatsapp.com/send?phone=${customerContact}&text=${encodeURIComponent(message)}`;

        // Open WhatsApp in a new tab with the PDF file attached
        const response = await fetch(url, {
            method: 'POST',
            body: formData
        });

        if (!response.ok) {
            throw new Error('Failed to send WhatsApp message.');
        }

        console.log('WhatsApp message sent successfully.');
    } catch (error) {
        console.error('Error sending WhatsApp message:', error);
        throw error;
    }
};

export async function fetchEngineerStockDetails(controller, companyId, engineerId, token) {
    try {
        const response = await apiService.get(`/${controller}/${companyId}/${engineerId}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}




export async function UPDATEDATASCHEDULE(controller, engineerId, data, token) {
    try {
        const response = await apiService.put(`/${controller}/${engineerId}/${data}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function fetchDairyDetails(controller, fromdate, todate, engineerId, companyId, token) {
    try {
        const response = await apiService.get(`/${controller}/${fromdate}/${todate}/${companyId}/${engineerId}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}
